var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-informations mx-3"
  }, [_c('div', {
    staticClass: "product-info-wrapper pa-3 d-flex flex-row flex-grow-1"
  }, [_c('div', {
    staticClass: "side-area font-weight-light flex-shrink-0 px-3"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("SKU-specific content")]), _vm._v(" is shown at the top of each landing page."), _c('br'), _c('br'), _vm._v("Information displayed here can be edited in the "), _c('iframe-link', {
    attrs: {
      "content": "Products tab",
      "link": "/#/products"
    }
  }), _vm._v(" and the Scan Response settings. 👉 "), !_vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "mt-7",
    attrs: {
      "align-content": "center",
      "justify": "start"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Can't edit the elements?")]), _c('info-tooltip', {
    staticClass: "more-tooltip ml-3",
    attrs: {
      "content": "<a href='/#/upgrade'>Upgrade today </a> to unlock more features"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "scan-result-area flex-grow-1"
  }, [_c('div', {
    staticClass: "scan-result-area-header font-weight-bold"
  }, [_vm._v("Top of Landing Page")]), _vm.isAvailable('editor:scan-result:logo') ? _c('div', {
    staticClass: "product-tool my-2 d-flex flex-row"
  }, [_c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1"
  }, [_c('v-switch', {
    staticClass: "ma-0 hide-disabled-style",
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Logo Banner"
    },
    model: {
      value: _vm.enableLogo,
      callback: function callback($$v) {
        _vm.enableLogo = $$v;
      },
      expression: "enableLogo"
    }
  })], 1), _c('div', {
    staticClass: "align-center flex-shrink-0"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:logo') || !_vm.enableLogo,
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.logoModal = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cog-outline")])], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "product-tool my-2 d-flex flex-row"
  }, [_vm._m(0), _c('div', {
    staticClass: "align-center flex-shrink-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.pictureModal = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cog-outline")])], 1)], 1)]), _c('div', {
    staticClass: "product-tool my-2 d-flex flex-row"
  }, [_c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1"
  }, [_c('span', [_vm._v("Scan Response: " + _vm._s(_vm.overrideAuthMessage ? _vm.authMessage[_vm.previewResult] : _vm.defaultAuthMessage[_vm.previewResult]))])]), _c('div', {
    staticClass: "align-center flex-shrink-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.textModal = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cog-outline")])], 1)], 1)]), _vm._m(1), _vm.isAvailable('editor:scan-result:serial-number') ? _c('div', {
    staticClass: "product-tool my-2 d-flex flex-row"
  }, [_c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1"
  }, [_c('v-switch', {
    staticClass: "ma-0",
    attrs: {
      "dense": "",
      "hide-details": "",
      "disabled": !_vm.isAvailable('editor:scan-result:serial-number'),
      "label": "Serial Number"
    },
    model: {
      value: _vm.showSerialNumber,
      callback: function callback($$v) {
        _vm.showSerialNumber = $$v;
      },
      expression: "showSerialNumber"
    }
  })], 1)]) : _vm._e()])]), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.logoModal,
      callback: function callback($$v) {
        _vm.logoModal = $$v;
      },
      expression: "logoModal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Logo")]), _c('v-card-text', [_c('div', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "d-flex flex-row inset pa-6"
  }, [!_vm.logo ? _c('ImageCropper', {
    attrs: {
      "input-key": "logo"
    },
    on: {
      "image-upload": _vm.onImageUpload
    }
  }) : _vm._e(), _vm.logo ? _c('div', {
    staticClass: "logo-ctn ml-3 d-flex flex-row align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  }), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteLogo
    }
  }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v("Supported formats:")]), _c('div', {
    staticClass: "font-weight-light"
  }, [_vm._v(" PNG without background color JPG with pure white background ")]), _c('div', {
    staticClass: "label font-weight-bold pt-3"
  }, [_vm._v("Recommended image height:")]), _c('div', {
    staticClass: "font-weight-light"
  }, [_vm._v(" Use square or horizontal version of your logo. ")])])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.logoModal = false;
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.pictureModal,
      callback: function callback($$v) {
        _vm.pictureModal = $$v;
      },
      expression: "pictureModal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Product Picture Settings")]), _c('v-card-text', [_c('div', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "py-3"
  }, [_c('span', {
    staticClass: "description font-weight-light"
  }, [_vm._v("Users will see different product picture depending on which product they scan. You can manage this in "), _c('iframe-link', {
    attrs: {
      "content": "Products",
      "link": "/#/products"
    }
  })], 1)]), _c('div', {
    staticClass: "inset pt-4"
  }, [_c('span', {
    staticClass: "label font-weight-medium"
  }, [_vm._v("Display mode")]), !_vm.isAvailable('editor:scan-result:display-mode') ? _c('info-tooltip', {
    staticClass: "ml-3",
    attrs: {
      "content": "<a href='/#/upgrade'>Upgrade today </a> to unlock this feature"
    }
  }) : _vm._e()], 1), _c('v-radio-group', {
    staticClass: "inset",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:display-mode'),
      "column": ""
    },
    model: {
      value: _vm.productImageDisplayMode,
      callback: function callback($$v) {
        _vm.productImageDisplayMode = $$v;
      },
      expression: "productImageDisplayMode"
    }
  }, [_c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "contain",
      "label": "Contain"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v("Best suited for product image that have a white background.")]), _c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "cover",
      "label": "Cover"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v("Best suited for product image with non-white background.")]), _c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "full-width",
      "label": "Full-width"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8"
  }, [_vm._v("This will scale your picture to the phone width increasing the overall size.")])], 1)], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.pictureModal = false;
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.textModal,
      callback: function callback($$v) {
        _vm.textModal = $$v;
      },
      expression: "textModal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Scan Response Text Settings")]), _c('v-card-text', [_c('div', {
    staticClass: "description font-weight-light pa-6"
  }, [_vm._v("Edit the text to display to users who scan your product's QR code")]), _c('div', {
    staticClass: "px-6"
  }, [_c('span', {
    staticClass: "label font-weight-bold"
  }, [_vm._v("Scan Response Text ")]), !_vm.isAvailable('editor:scan-result:text') ? _c('info-tooltip', {
    staticClass: "ml-3",
    attrs: {
      "content": "<a href='/#/upgrade'>Upgrade today </a> to unlock this feature"
    }
  }) : _vm._e()], 1), !_vm.isAvailable('editor:authentication') ? _c('div', [_c('v-text-field', {
    staticClass: "pa-0 px-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": "Enter a customized text"
    },
    model: {
      value: _vm.authMessageOverride.active,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "active", $$v);
      },
      expression: "authMessageOverride.active"
    }
  })], 1) : _vm._e(), _vm.isAvailable('editor:authentication') ? _c('div', [_c('div', {
    staticClass: "px-6"
  }, [_c('v-radio-group', {
    staticClass: "inset ma-0",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text'),
      "column": ""
    },
    model: {
      value: _vm.overrideAuthMessage,
      callback: function callback($$v) {
        _vm.overrideAuthMessage = $$v;
      },
      expression: "overrideAuthMessage"
    }
  }, [_c('v-radio', {
    staticClass: "py-2 ma-0",
    attrs: {
      "value": false,
      "label": "Default Scan Response Text"
    }
  }), _c('v-radio', {
    staticClass: "ma-0",
    attrs: {
      "value": true,
      "label": "Customized Scan Response Text"
    }
  })], 1)], 1), _c('div', {
    staticClass: "table pl-14"
  }, [_c('div', {
    staticClass: "d-flex flex-row table-header"
  }, [_c('div', {
    staticClass: "item font-weight-bold text-caption"
  }, [_vm._v("Default text")]), _c('div', {
    staticClass: "item font-weight-bold text-caption"
  }, [_vm._v("Customized text")])]), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Genuine")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": "Enter a customized text"
    },
    model: {
      value: _vm.authMessageOverride.genuine,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "genuine", $$v);
      },
      expression: "authMessageOverride.genuine"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Active Code")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": "Enter a customized text"
    },
    model: {
      value: _vm.authMessageOverride.active,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "active", $$v);
      },
      expression: "authMessageOverride.active"
    }
  })], 1)]), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Unable To Verify")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": "Enter a customized text"
    },
    model: {
      value: _vm.authMessageOverride.fake,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "fake", $$v);
      },
      expression: "authMessageOverride.fake"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v("Powered by Scantrust")]), _c('v-switch', {
    staticClass: "ma-0 pt-4",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:branding'),
      "hide-details": "",
      "label": "Display the Scantrust brand text: ".concat(_vm.enableBranding ? 'Yes' : 'No')
    },
    model: {
      value: _vm.enableBranding,
      callback: function callback($$v) {
        _vm.enableBranding = $$v;
      },
      expression: "enableBranding"
    }
  })], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.textModal = false;
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1"
  }, [_c('span', [_vm._v("Product Picture")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-tool my-2 d-flex flex-row"
  }, [_c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1"
  }, [_c('span', [_vm._v("Product Name")])])]);

}]

export { render, staticRenderFns }